
SupportTaglineHelper =
  create: ->
    if Groupon.Support.currentOrder?.tagLine
      if Groupon.Support.ABOUT_AN_ORDER is true
        return "#{Groupon.Support.currentOrder.tagLine},about_an_order"
      else
        return Groupon.Support.currentOrder.tagLine

    tagLine = {}
    memo = ""
    tagLine.userState = "not_signed_in" unless currentUser?
    tagLine.orderNotListed = "order_not_listed" if Groupon.Support.ORDER_NOT_LISTED is true
    tagLine.notOrderRelated = "not_order_related" if Groupon.Support.NOT_ORDER_RELATED is true
    tagLine.accountRelated = "account_related" if Groupon.Support.ACCOUNT_RELATED is true
    tagLine.prePurchase = "making_a_purchase" if Groupon.Support.PRE_PURCHASE is true
    tagLine.others = "something_else" if Groupon.Support.SOMETHING_ELSE is true
    unless _.isEmpty tagLine
        return _.reduce tagLine, (memo, tag) => "#{memo},#{tag}"
    else
        return ""

module.exports = SupportTaglineHelper
